import { render, staticRenderFns } from "./AddQuestions.vue?vue&type=template&id=b5ae03a2&scoped=true"
import script from "./AddQuestions.vue?vue&type=script&lang=js"
export * from "./AddQuestions.vue?vue&type=script&lang=js"
import style0 from "./AddQuestions.vue?vue&type=style&index=0&id=b5ae03a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ae03a2",
  null
  
)

export default component.exports